import { createContext, useContext } from "react";

export type TaskFocusModeController = {
  isFocused: boolean;
  isChanging: boolean;
  toggle: () => void;
};

export const TaskFocusModeContext = createContext<TaskFocusModeController | null>(null);

export function useTaskFocusMode(): TaskFocusModeController | null {
  return useContext(TaskFocusModeContext);
}
